<template>
  <ul class="onstar__menu" v-touch:swipe.down="close">
    <li @click="callOnstar">
      <p>I might need help for my personal safety.</p>
      <img src="../assets/icons/onstar.png" alt="onstar logo" />
    </li>
    <li @click="callOnstar">
      <p>I want to request Police, Fire, or EMS for someone else.</p>
      <img src="../assets/icons/onstar.png" alt="onstar logo" />
    </li>
    <li @click="callOnstar">
      <p>I need help with my account.</p>
      <img src="../assets/icons/phone.png" alt="onstar logo" />
    </li>
    <li @click="callOnstar">
      <p>I need help with my app.</p>
      <img src="../assets/icons/phone.png" alt="onstar logo" />
    </li>
    <li @click="close">
      <span>X</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Menu",
  props: {
    close: Function
  },
  methods: {
    callOnstar() {
      this.$router.push("onstar");
    },
    callSos() {
      this.$router.push({ path: `sos/true` });
    }
  }
};
</script>

<style lang="scss" scoped>
.onstar__menu {
  color: #fff;
  background-color: var(--black);
  position: absolute;
  bottom: 4.15%;
  left: 0;
  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 0 0;
  align-items: left;
  text-align: left;
  max-height: 70%;
  font-size: 1.5rem;
  width: 100%;
  z-index: 10;
  transform: translateY(+150%);
  transition: all 500ms ease-in-out;
  margin: 0;
  padding: 0;

  @media only screen and (max-height: 800px) {
    bottom: 6.75%;
  }

  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid grey;
    padding: 0.5rem 0;

    p {
      width: 60%;
      margin-left: 10%;
    }

    img {
      width: 40px;
      height: 40px;
      align-items: right;
      margin-right: 10%;
    }
  }

  li:hover {
    cursor: pointer;
  }

  li:last-of-type {
    justify-content: center;
    font-size: 1.75rem;
    padding: 0.75rem 0;
  }

  .active & {
    transform: translateY(0%);
  }
}
</style>
